function o({
  utilityColor: t,
  emphasis: n
}) {
  return `${t}-${n}-content`;
}
export {
  o as getUtilityContentColorRole
};
